module.exports = __webpack_public_path__ + "img/20200102154740360截图20200102112021696.a4e1959a.jpg";